/* @ngInject */
const TemporaryLoginTokenRepository = function (baseRepository) {
    angular.extend(this, baseRepository);

    this.getSingleUseToken = () => {
        const url = '/rest/Session/singleUseToken';

        return this.get(url);
    };
};

angular.module('gw-um-auth')
    .service('temporaryLoginTokenRepository', TemporaryLoginTokenRepository);
